<template>
    <a v-if="!isLogin" :href="'https://bit.ly/3JjdAJt'" target="_blank" id="header_submit_sehseh" class="btn primary sm gtm-trigger-element" data-gtm-category="header" data-gtm-label="subscribe" data-gtm-value="">
        <span class="btn_text gtm-trigger-element" data-gtm-category="header" data-gtm-label="subscribe" data-gtm-value="">免費訂閱</span>
    </a>
    <div id="header_member_wrapper" class="dropdown show">
      <a v-if="isLogin" href="javascript: void(0);" id="go_member" class="header_member_btn dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <svg class="member_icon" viewBox="0 0 32 32"  xmlns="http://www.w3.org/2000/svg">
          <path d="M16 16C19.3137 16 22 13.3137 22 10C22 6.68629 19.3137 4 16 4C12.6863 4 10 6.68629 10 10C10 13.3137 12.6863 16 16 16Z" />
          <path d="M27.9517 23.8521C28 24.1602 28 24.4959 28 25.1672V25.3167C28 25.9522 28 26.2699 27.9284 26.5302C27.7415 27.2102 27.2102 27.7415 26.5302 27.9284C26.2699 28 25.9522 28 25.3167 28H6.68328C6.0478 28 5.73005 28 5.46977 27.9284C4.78979 27.7415 4.25853 27.2102 4.07157 26.5302C4 26.2699 4 25.9522 4 25.3167V25.1672C4 24.4959 4 24.1602 4.04835 23.8521C4.21505 22.7897 4.8025 21.8392 5.67818 21.215C5.93217 21.0339 6.23238 20.8838 6.83282 20.5836C8.79671 19.6016 9.77866 19.1107 10.7655 18.769C14.1564 17.5951 17.8436 17.5951 21.2345 18.769C22.2213 19.1107 23.2033 19.6016 25.1672 20.5836C25.7676 20.8838 26.0678 21.0339 26.3218 21.215C27.1975 21.8392 27.785 22.7897 27.9517 23.8521Z" />
        </svg>
      </a>
      <div v-if="isLogin" class="dropdown-menu" aria-labelledby="go_member">
        <a class="dropdown-item" href="/member/manage">會員專區</a>
        <a class="dropdown-item" href="/terms-of-service">會員服務條款</a>
        <div class="dropdown-divider"></div>
        <a class="btn text md dropdown-item" id="logout_btn" href="javascript: void(0);" @click="doLogout">登出</a>
      </div>
      <a v-else href="javascript: void(0);" id="go_login" class="header_member_btn gtm-trigger-element" :data-gtm-category="'header'" :data-gtm-label="'login'" :data-gtm-value="''"
        @click="showLogin">登入</a>
      <a href="/search" class="header_member_btn" id="go_search">
          <svg class="search_icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.4414 19.4456C19.9314 18.9556 19.9314 18.1656 19.4414 17.6756L15.8614 14.0956C16.9514 12.6456 17.6014 10.8456 17.6014 8.89561C17.6014 4.09561 13.6914 0.185608 8.89141 0.185608C4.09141 0.185608 0.191406 4.10561 0.191406 8.90561C0.191406 13.7056 4.10141 17.6156 8.90141 17.6156C10.8514 17.6156 12.6514 16.9656 14.1014 15.8756L17.6814 19.4556C18.1614 19.9356 18.9514 19.9356 19.4414 19.4456ZM8.90141 15.1056C5.48141 15.1056 2.69141 12.3256 2.69141 8.89561C2.69141 5.46561 5.47141 2.69561 8.90141 2.69561C12.3314 2.69561 15.1114 5.47561 15.1114 8.90561C15.1114 12.3356 12.3214 15.1056 8.90141 15.1056Z"/>
          </svg> 
      </a>
     </div>
</template>

<script>
import { useStore } from 'vuex';
import { logoutPost } from '@vuePath/api/login';

export default {
  name: "MemberBtn",
  setup() {
    // Check if has nid for utm
    const nid = document.getElementById('hidden_nid') ? document.getElementById('hidden_nid').value : 'none';

    const store = useStore();

    const isLogin = store.getters['auth/isAuthenticated'];

    const showLogin = () => { store.dispatch('auth/ShowLogin'); };

    const logout = () => { store.dispatch("auth/Logout"); };

    const doLogout = async () => {
      await logoutPost().then((res) => {
        logout();
      }).catch((err) => {
        console.log(err);
      });
    };

    return { isLogin, showLogin, logout, doLogout, nid };
  },
}
</script>